module.exports = __webpack_public_path__ + "static/media/cardReader.ddb1a20f.jpg";